import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f4ec290"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work-type-radio" }
const _hoisted_2 = ["name", "value", "id", "checked"]
const _hoisted_3 = ["for"]

import { v4 as uuidv4 } from "uuid";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkTypeRadio',
  props: {
  value: {
    type: Number,
    required: true
  },
  name: {
    type: String,
    default: ""
  },
  id: {
    type: String,
    default: uuidv4()
  },
  text: {
    type: String,
    default: ""
  },
  checked: {
    type: Boolean,
    default: false
  }
},
  emits: ["change"],
  setup(__props, { emit }) {




const onChange = (e: Event) => {
  if (!(e.target instanceof HTMLInputElement)) {
    return;
  }
  emit("change", e.target.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "radio",
      name: __props.name,
      value: __props.value,
      id: __props.id,
      class: "work-type-radio-input",
      checked: __props.checked,
      onChange: onChange
    }, null, 40, _hoisted_2),
    _createTextVNode(),
    _createElementVNode("label", {
      for: __props.id,
      class: "work-type-radio-label"
    }, _toDisplayString(__props.text), 9, _hoisted_3)
  ]))
}
}

})